import { useEffect, useState } from 'react'
import { ChartHeaderProps } from './Header.types'

export const useIsExpanded = (props: ChartHeaderProps): {
  isExpanded: boolean,
  setIsExpanded: (value: boolean) => void
} => {
  const {
    onCollapseClick,
    onExpandClick,
    initialIsExpandedState
  } = props

  const [justMounted, setJustMounted] = useState<boolean>(true)
  const [isExpanded, setIsExpanded] = useState<boolean>(Boolean(initialIsExpandedState))

  useEffect(() => {
    if (justMounted) {
      setJustMounted(false)
      return
    }

    if (isExpanded) {
      onExpandClick && onExpandClick()
    } else {
      onCollapseClick && onCollapseClick()
    }

    // eslint-disable-next-line
  }, [isExpanded, onExpandClick, onCollapseClick])

  return {
    isExpanded,
    setIsExpanded
  }
}
